'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tf = require('@tensorflow/tfjs');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var tf__namespace = /*#__PURE__*/_interopNamespace(tf);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var GraphConvLayer = /*#__PURE__*/function (_tf$layers$Layer) {
  _inherits(GraphConvLayer, _tf$layers$Layer);

  var _super = _createSuper(GraphConvLayer);

  function GraphConvLayer(options) {
    var _this;

    _classCallCheck(this, GraphConvLayer);

    _this = _super.call(this, options);
    Object.keys(options).forEach(function (key) {
      _this[key] = options[key];
    });
    _this.useBias = true;
    _this.biasInitializer = tf.initializers.zeros();
    _this.biasRegularizer = null;
    return _this;
  }

  _createClass(GraphConvLayer, [{
    key: "computeOutputShape",
    value: function computeOutputShape() {
      return [null, this.units];
    }
  }, {
    key: "build",
    value: function build() {
      _get(_getPrototypeOf(GraphConvLayer.prototype), "build", this).call(this);

      this.kernel = this.addWeight('kernel', [this.inputDim, this.units], null, this.kernelInitializer, this.kernelRegularizer, true);

      if (this.useBias) {
        this.bias = this.addWeight('bias', [this.units], null, this.biasInitializer, this.biasRegularizer, true);
      } else {
        this.bias = null;
      }

      this.built = true;
    }
  }, {
    key: "call",
    value: function call(inputs) {
      var _this2 = this;

      return tf.tidy(function () {
        var featureShape = inputs[0].shape;
        var features = featureShape[0] === 1 && inputs[0].squeeze([0]) || inputs[0]; // 兼容特征大小为1的时候

        var basis = inputs[1].squeeze([0]);
        var output = tf.dot(basis, features);
        output = tf.dot(output, _this2.kernel.read());
        if (_this2.bias) output = output.add(_this2.bias.read());

        if (typeof _this2.activation === 'string') {
          var activation = tf__namespace[_this2.activation];

          if (_this2.activation === 'primary') {
            activation = function activation(x) {
              return x;
            };
          }

          return activation(output);
        }

        return _this2.activation(output);
      });
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var basicConfig = _get(_getPrototypeOf(GraphConvLayer.prototype), "getConfig", this).call(this);

      var config = {
        units: this.units,
        support: this.support,
        activation: this.activation,
        useBias: this.useBias,
        inputDim: this.inputDim,
        kernelInitializer: this.kernelInitializer,
        biasInitializer: this.biasInitializer,
        kernelRegularizer: this.kernelRegularizer,
        biasRegularizer: this.biasRegularizer,
        activityRegularizer: this.activityRegularizer,
        kernelConstraint: this.kernelConstraint,
        biasConstraint: this.biasConstraint
      };
      return _objectSpread2(_objectSpread2({}, basicConfig), config);
    }
  }]);

  return GraphConvLayer;
}(tf.layers.Layer);

GraphConvLayer.className = 'GraphConvLayer';
tf.serialization.registerClass(GraphConvLayer);

var GraphPoolingLayer = /*#__PURE__*/function (_tf$layers$Layer) {
  _inherits(GraphPoolingLayer, _tf$layers$Layer);

  var _super = _createSuper(GraphPoolingLayer);

  function GraphPoolingLayer() {
    _classCallCheck(this, GraphPoolingLayer);

    return _super.apply(this, arguments);
  }

  _createClass(GraphPoolingLayer, [{
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      return [1, 4];
    }
  }, {
    key: "call",
    value: function call(inputs) {
      return tf.tidy(function () {
        var nodesNum = inputs[0].shape[0];
        var kernel = [];

        for (var i = 0; i < nodesNum; i++) {
          kernel.push(1 / nodesNum);
        }

        var poolingKernel = tf.tensor2d([kernel]);
        var output = tf.dot(poolingKernel, inputs[0]);
        return tf.softmax(output);
      });
    }
  }]);

  return GraphPoolingLayer;
}(tf.layers.Layer);

GraphPoolingLayer['className'] = 'GraphPoolingLayer';
tf.serialization.registerClass(GraphPoolingLayer);

var featureProcess = function featureProcess(nodes, edges, featureCount) {
  var nodesMap = {};
  var nodesNumber = nodes.length;
  var adjacentMatrix = new Array(nodesNumber);
  var featureMatrix = new Array(nodesNumber); // 构建邻接矩阵

  for (var i = 0; i < adjacentMatrix.length; i++) {
    adjacentMatrix[i] = new Array(nodesNumber).fill(0);
  } // 构建节点特征矩阵


  for (var _i = 0; _i < featureMatrix.length; _i++) {
    featureMatrix[_i] = new Array(featureCount).fill(0);
  }

  for (var _i2 = 0; _i2 < adjacentMatrix.length; _i2++) {
    for (var j = 0; j < adjacentMatrix.length; j++) {
      if (_i2 === j) adjacentMatrix[_i2][j] = 1;
    }
  }

  nodes.forEach(function (node, index) {
    nodesMap[node.id] = index;
    var outDegree = edges.filter(function (item) {
      return item.from === node.id;
    }).length;
    var inDegree = edges.filter(function (item) {
      return item.to === node.id;
    }).length; // 特征矩阵初始化

    for (var _i3 = 0; _i3 < featureCount; _i3++) {
      featureMatrix[index][_i3] = (outDegree + inDegree) / featureCount;
    }
  });
  edges.forEach(function (edge) {
    var to = edge.to,
        from = edge.from;
    var toIndex = nodesMap[to];
    var fromIndex = nodesMap[from];
    if (toIndex === undefined || fromIndex === undefined) return;
    adjacentMatrix[fromIndex][toIndex] = 1;
    adjacentMatrix[toIndex][fromIndex] = 1;
  });
  var adjTensor = tf.tensor2d(adjacentMatrix);
  var featureTensor = tf.tensor2d(featureMatrix); // @ts-ignore

  var D = tf.diag(tf.pow(adjTensor.sum(1), tf.tensor(-0.5)).flatten(), 0); // 加权平均邻接特征

  var adjNormlized = adjTensor.dot(D).transpose().dot(D); // 节点特征矩阵为稀疏矩阵，需要对特征值进行最小值剪裁，否则会出现NaN

  var featuerNormlized = featureTensor.div(featureTensor.sum(1).reshape([-1, 1]).clipByValue(1e-8, Infinity));
  return [featuerNormlized.expandDims(0), adjNormlized.expandDims(0)];
};
var transGraphData = function transGraphData(data) {
  var _data$nodes = data.nodes,
      nodes = _data$nodes === void 0 ? [] : _data$nodes,
      _data$edges = data.edges,
      edges = _data$edges === void 0 ? [] : _data$edges;
  var nodesData = [];
  var edgesData = [];
  nodes.forEach(function (item) {
    nodesData.push({
      id: String(item.id)
    });
  });
  edges.forEach(function (edge) {
    edgesData.push({
      from: String(edge.source || edge.from),
      to: String(edge.target || edge.to)
    });
  });
  return {
    nodes: nodesData,
    edges: edgesData
  };
};
var predictLog = function predictLog(predictedRes, confidence, expectLayout) {
  console.log('%c@antv/vis-predict-engine图布局预测', 'color: #99CCCC;font-size: 16px;');

  if (expectLayout) {
    console.log('%c期望布局', 'background: #FFCC99;color:#fff;padding:5px;border-radius:5px;', expectLayout);
  }

  console.log('%c预测布局', 'background: #CCCCFF;color: #fff;padding:5px;border-radius:5px;', predictedRes);
  console.log('%c置信度', 'background: #FF9966;color: #fff;padding:5px;border-radius:5px;', confidence);
};

var LayoutTypes = ['force', 'radial', 'concentric', 'circular'];
var model = null;

var loadModel = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (model) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return tf.loadLayersModel('https://gw.alipayobjects.com/os/bmw-prod/c86b2dbb-ed03-421d-b080-2aad75cf4d47.json').then(function (loadedModel) {
              model = loadedModel;
            });

          case 3:
            return _context.abrupt("return", model);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadModel() {
    return _ref.apply(this, arguments);
  };
}();

var getModel = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var loadedModel;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return loadModel();

          case 2:
            loadedModel = _context2.sent;
            return _context2.abrupt("return", loadedModel);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getModel() {
    return _ref2.apply(this, arguments);
  };
}();

var predictRes = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
    var graphData;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(data.nodes.length === 1)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", [0, 0, 0, 1]);

          case 2:
            graphData = featureProcess(data.nodes, data.edges, 32);
            _context3.next = 5;
            return model.predict(graphData).data();

          case 5:
            return _context3.abrupt("return", _context3.sent);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function predictRes(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var index = {
  predict: function predict(data, expectLayout, showLog) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var graphData, resData, predictLayout, confidence;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              graphData = transGraphData(data);
              _context4.next = 3;
              return getModel();

            case 3:
              if (!(Array.isArray(data === null || data === void 0 ? void 0 : data.nodes) && (data === null || data === void 0 ? void 0 : data.nodes.length) > 0)) {
                _context4.next = 11;
                break;
              }

              _context4.next = 6;
              return predictRes(graphData);

            case 6:
              resData = _context4.sent;
              predictLayout = LayoutTypes[resData.indexOf(Math.max.apply(Math, _toConsumableArray(resData)))];
              confidence = "".concat((Math.max.apply(Math, _toConsumableArray(resData)) * 100).toFixed(2), "%");

              if (showLog) {
                predictLog(predictLayout, confidence, expectLayout);
              }

              return _context4.abrupt("return", {
                predictLayout: predictLayout,
                confidence: confidence
              });

            case 11:
              return _context4.abrupt("return", {});

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};

exports.GraphLayoutPredict = index;
